module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAdgAAAHYBTnsmCAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAEPSURBVDiNldK9SkNBEAXgj4ARe1sVGwujoJU2llb6FNpbaO8bGAwG7SztBBsrf0pfIEllFaxsE0WF609x98q6NyZk4MAws+fMzGEpxzIaaOMloI1jLA14/xuTOMUnvv9Bhiaqg8j3Q4gp7lKRszHIBU7im4etXWAXj8k5NcGcUeTrMGwzqdehM4L8ivno3Iuo16pgJmpe4ioxuIONkC+gG/XmoBcprmEK78kWD4FwkNR7FTxFilt4wx4+Qu0Z+yHfTrbr8tfEPlZCcxqrYSPYUfanTv49s0TkEOuYlTt/jq+EnGGxWKU5QH0UGvEtVdyOQb7BROKHqvx7ZkOIWZhcIsdRC+a0gh/9kB/FNxfxA3/Nnl/syHcOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/uturn.png
// module id = 5eUW
// module chunks = 0 138